import { render } from "./EditP2POffer.vue?vue&type=template&id=0d06ce94&scoped=true"
import script from "./EditP2POffer.vue?vue&type=script&lang=js"
export * from "./EditP2POffer.vue?vue&type=script&lang=js"

import "./EditP2POffer.vue?vue&type=style&index=0&id=0d06ce94&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d06ce94"]])

export default __exports__